<template>
  <breadCrumbs title="Cart" main="Ecommerce " title1="Cart" />

  <div class="container-fluid text-start">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <h3>Cart</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <emptyCart />
              <productCart />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import emptyCart from "./emptyCart.vue"
import productCart from "./productCart.vue"
import { mapState } from "vuex";
export default {
  components: { emptyCart, productCart },
  data() {
    return {
      counter: 1,
    };
  },
  computed: {
    ...mapState({
      cart: (state) => state.product.cart,
      getAmount() {
        return (this.totalAmount = this.$store.getters["product/getTotalAmount"]);
      },
    }),
  },
  methods: {
    getImgUrl(path) {
      return require("../../../assets/images/" + path);
    },
    removeProduct: function (product) {
      this.$store.dispatch("product/removeProduct", product);
    },
    increment(product, qty = 1) {
      this.$store.dispatch("product/updateCartQuantity", { product: product, qty: qty, });
    },
    decrement(product, qty = -1) {
      this.$store.dispatch("product/updateCartQuantity", { product: product, qty: qty, });
    },
  },
};
</script>